import React, { useState, useEffect } from 'react';
import {
  useOnboardingContext,
  useCompanyContext,
  useLinesContext,
} from '../../../../contexts';
import {
  getProducts,
  getShopifyProducts,
  SortDirections,
} from '../../../../components/API';
import { ESellerStore as Platform } from '../../../../Types';
import { useHistory } from 'react-router-dom';
import { pathname } from '../../../../utils';
import { getHeader, getSubHeader } from './utils';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Stepper from '../../../../components/Onboarding/BuildingBlocks/OnboardingWrapper';
import LoadingBackdrop from '../../../../components/LoadingBackdrop';
import ProductAsinLayout from '../../../../components/Onboarding/Product/Asin';
import SelectProductLayout from '../../../../components/Onboarding/Product/SelectProduct';
import VerifyProduct from '../../../../components/Onboarding/Product/VerifyProduct';
import Button from '@material-ui/core/Button';
import NoProduct from '../../../../components/Onboarding/Product/NoProduct';
import { is8DataApp } from '../../../../utils';

const useStyles = makeStyles((theme: any) => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(4),
    minWidth: 200,
  },
  button: { fontSize: '1.2em' },
}));

export default function Product() {
  const history = useHistory();
  const classes = useStyles();
  const [sellerProducts, setSellerProducts] = useState(null);
  const { loading } = useOnboardingContext();
  const { business } = useCompanyContext();
  const { products } = useLinesContext();
  const [displayVerifyProduct, setDisplayVerifyProduct] = useState(false);
  const [gettingProducts, setGettingProducts] = useState(false);
  const [productDetails, setProductDetails] = useState(null);
  const is8Data = is8DataApp();

  async function getProductsWrapper() {
    setGettingProducts(true);
    try {
      const products = is8Data
        ? await getShopifyProducts()
        : await getProducts('best_rank', SortDirections.asc, false);
      setSellerProducts(products);
    } catch (error) {
      setSellerProducts([]);
    }
    setGettingProducts(false);
  }

  useEffect(() => {
    getProductsWrapper();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (business && business.sellerStore !== Platform.amazon && !is8Data) {
      history.push(pathname.onboarding.extras.productUrl.url);
    }
  }, [history, business, is8Data]);

  const hasSellerProducts = !!sellerProducts?.length;

  return (
    <>
      <LoadingBackdrop open={loading || gettingProducts} />
      <Stepper
        title={getHeader({
          hasSellerProducts,
          displayVerifyProduct,
          product: productDetails,
        })}
        subtitle={getSubHeader({ hasSellerProducts })}
        hideContent={!(products && business && sellerProducts)}
        headerWidth={800}
        contentWidth={1200}
      >
        {hasSellerProducts && (
          <>
            <SelectProductLayout allSellerProducts={sellerProducts} />
            {!is8Data && (
              <div className={classes.buttonContainer}>
                <Button
                  color="primary"
                  variant="contained"
                  className={classes.button}
                  onClick={() => setSellerProducts([])}
                  data-automation-id="none"
                >
                  None of these
                </Button>
              </div>
            )}
          </>
        )}
        {!hasSellerProducts && (
          <>
            {!displayVerifyProduct && (
              <>
                <ProductAsinLayout
                  verifyProduct={(asin, name, image, url, bestRank) => {
                    setProductDetails({
                      asin,
                      name,
                      image,
                      url,
                      bestRank,
                    });
                    setDisplayVerifyProduct(true);
                  }}
                  lastAsinChecked={productDetails?.asin}
                />
                <NoProduct header="No product ASIN?" />
              </>
            )}
            {displayVerifyProduct && (
              <VerifyProduct
                product={productDetails}
                tryAgain={() => {
                  setDisplayVerifyProduct(false);
                }}
              />
            )}
          </>
        )}
      </Stepper>
    </>
  );
}
